<template>
  <div class="rotation-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newRotation()">添加轮播图</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange" v-viewer>
      <template slot="image" slot-scope="text, data">
        <dy-image :src="data.banner"></dy-image>
      </template>
      <template slot="enable" slot-scope="text, data">
        <template v-if="(!isPlatformRole && data.generate_source === 'platform') || (isPlatformRole && data.generate_source === 'community')">
        </template>
        <template v-else>
          <a-switch :checked="data.enable === 1" :loading="data.stateLoading" @change="onChange(data)" />
        </template>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <template v-if="(!isPlatformRole && data.generate_source === 'platform') || (isPlatformRole && data.generate_source === 'community')">
            <a-button type="link" @click="scanRotation(data)">查看</a-button>
          </template>
          <template v-else>
            <a-button type="link" @click="editRotation(data)">编辑</a-button>
            <a-button type="link" @click="changeRotationSort(data, 1)">上移</a-button>
            <a-button type="link" @click="changeRotationSort(data, 2)">下移</a-button>
            <a-button type="link" @click="deleteRotation(data)">删除</a-button>
          </template>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="50%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <rotation-info :id="drawer.id" is-scan></rotation-info>
    </a-drawer>
  </div>
</template>
<script>
  import CommunityService from '@/io/community.js';
  import RotationService from "@/io/rotation.js";
  import RotationInfo from "@/views/community/RotationInfo.vue";

  export default {
    name: "RotationManage",
    data() {
      let self = this;
      return {
        communityOptions: [],
        table: {
          loading: false,
          search: {
            name: null,
            type: [],
            community: [],
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '轮播图',
              scopedSlots: { customRender: 'image' },
            },
            {
              title: '轮播名称',
              dataIndex: 'title',
            },
            {
              title: '跳转类型',
              dataIndex: 'jumpWayText',
            },
            {
              title: '来源',
              dataIndex: 'sourceText',
            },
            {
              title: '是否显示',
              scopedSlots: { customRender: 'enable' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            },
          ],
        },
        drawer: {
          id: null,
          title: '轮播详情',
          show: false,
        }
      }
    },
    activated() {
      this.initCommunity().then(() => {
        this.initData();
      });
    },
    components: {
      RotationInfo
    },
    methods: {
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      onChange(data) {
        let checked = data.enable === 1;
        data.stateLoading = true;
        RotationService.changeEnable(data.id).then((res) => {}).catch((err) => {}).finally(() => {
          data.enable = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      changeRotationSort(data, sort){
        RotationService.changeSort(data.id, sort).then((res) => {
          this.initData();
        }).catch((err) => {}).finally(() => {});
      },
      deleteRotation(data){
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此轮播？',
          onOk() {
            RotationService.del(data.id).then((res) => {
              self.initData();
            }).catch((err) => {})
          }
        });
      },
      newRotation() {
        this.table.page.current = 1;
        this.$router.push({
          name: 'NewRotation'
        });
      },
      scanRotation(data) {
        this.drawer.id = data.id;
        this.drawer.show = true;
      },
      editRotation(data) {
        this.$router.push({
          name: 'EditRotation',
          params: {
            id: data.id
          }
        });
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initData() {
        this.table.loading = true;
        RotationService.listPage(
          this.table.page.current,
          this.table.page.pageSize
        ).then((res) => {
          this.table.data = res.data.map(val => {
            if (val.generate_source === 'platform') {
              val.sourceText = '平台';
            } else {
              this.communityOptions.forEach(m => {
                if (m.id === val.x_community_id) {
                  val.sourceText = m.name;
                }
              });
            }
            val.stateLoading = false;
            val.jumpWayText = val.jump_way === 1 ? '社区应用' : '外部链接';
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        })
        .catch((err) => {})
        .finally(() => {
          this.table.loading = false;
        });
      },
    },
  };
</script>

<style lang="less" scoped>

</style>